<template>
  <div>
    <transition name="fade">
      <div v-if="syncIsOpen" class="modal-backdrop"></div>
    </transition>
    <transition name="fade">
      <div v-if="syncIsOpen" class="modal">
        <div class="modal__header">
          <span>{{ title }}</span>
          <CloseBoldIcon :onClose="closeHandler" class="close-icon" />
        </div>
        <div class="modal__body">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CloseBoldIcon from '@/assets/icons/close.vue'
import { computed, onMounted, onUnmounted } from '@vue/composition-api'

export default {
  components: { CloseBoldIcon },
  props: ['value', 'title'],
  setup(props, ctx) {
    const syncIsOpen = computed({
      get: () => {
        if (props.value) document.body.style.overflow = 'hidden'
        if (!props.value) document.body.style.overflow = ''

        return props.value
      },
      set: (v) => ctx.emit('input', v)
    })

    function closeHandler() {
      syncIsOpen.value = false
    }

    onMounted(() => {
      document.body.addEventListener('keydown', closeHandler)
    })

    onUnmounted(() => {
      document.body.removeEventListener('keydown', closeHandler)
      document.body.style.overflow = ''
    })

    return { syncIsOpen, closeHandler }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
  z-index: 20;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  z-index: 20;
}
</style>
